import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-3 timeline-block" }
const _hoisted_2 = { class: "timeline-content" }
const _hoisted_3 = {
  key: 0,
  class: "badge badge-sm bg-gradient-danger me-1"
}
const _hoisted_4 = { class: "mt-1 mb-0 text-xs text-secondary font-weight-normal" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "text-xxs text-secondary mb-0" }
const _hoisted_7 = {
  key: 2,
  class: "badge badge-sm bg-gradient-success me-1"
}
const _hoisted_8 = {
  key: 3,
  class: "badge badge-sm bg-gradient-danger me-1"
}
const _hoisted_9 = {
  key: 4,
  class: "badge badge-sm bg-gradient-danger me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.getPedido.status_entrega==5)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " aguardando início"))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_ctx.toHora(_ctx.getPedido.janela_entrega_inicio)), 1),
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(_ctx.toHora(_ctx.getPedido.janela_entrega_fim)), 1)
      ]),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: _normalizeClass(["mt-3 mb-2 text-sm", _ctx.$parent.dark ? 'text-white' : 'text-dark'])
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.getPedido.endereco1_cliente || '' + " " + _ctx.getPedido.endereco2_cliente || '') + ", " + _toDisplayString(_ctx.getPedido.numero_cliente || '') + " - " + _toDisplayString(_ctx.getPedido.bairro_cliente || ''), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getPedido.cidade_cliente) + "/" + _toDisplayString(_ctx.getPedido.estado_cliente), 1)
          ], 2))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badges, (badge, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: index,
          class: _normalizeClass(`badge badge-sm bg-gradient-${_ctx.icon.color} me-1`)
        }, _toDisplayString(badge), 3))
      }), 128)),
      (_ctx.getPedido.pagamento_status=='paid')
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " pago"))
        : _createCommentVNode("", true),
      (_ctx.getPedido.status_entrega==0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " não iniciado"))
        : _createCommentVNode("", true),
      (!_ctx.getPedido.conferido)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, " não conferido"))
        : _createCommentVNode("", true)
    ])
  ]))
}